import { useEffect } from 'react';
import { DateRangeField, useFormField } from '@frontend/design-system';
import { DateRange } from './types';
import { formatRange } from './utils/format-range';
import { rangeHasDate } from './utils/range-has-date';

type Props = {
  name: string;
  onChange: (value: DateRange | undefined) => void;
  resetKey: number;
  value: DateRange;
};

export const DateFilter = ({ name, onChange, resetKey, value }: Props) => {
  const dateRangeField = useFormField({ type: 'dateRange', value: formatRange(value, 'MM/DD/YYYY'), required: true }, [
    resetKey,
  ]);

  // This useEffect is needed to ensure onChange is passed the complete DateRange (instead of the partial DateRange the user just entered)
  useEffect(() => {
    if (dateRangeField.value !== value) {
      const range = rangeHasDate(dateRangeField.value) ? dateRangeField.value : undefined;
      onChange(range);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRangeField.value]); // TODO: Exhaustively listing all dependencies will cause an infinite loop. Fixing this requires a larger architectural change.

  return <DateRangeField {...dateRangeField} label='' name={name} />;
};
